/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import ErrorName from '../error/error-name';

// TODO: To zde nepatří, když je to deterministic specific.
// TODO: Neslušná nekonfigurovatelná konstanta interval = 5, kdo ví v jaké jednotce.
/**
 * Sledovač času.
 * @param {number} timeUs Čas, ve kterém dojde k resolvování Promise.
 * @param {GetNow} getNow Funkce, která zjistí aktuální čas.
 * @param {Object} [opts={}]
 * @param {AbortSignal} [opts.abortSignal] Signál pro předčasné přerušení.
 * @returns {Promise<void>}
 */
export default function promisifyTimeWatcher(
  timeUs,
  getNow,
  { abortSignal = new AbortSignal() } = {}
) {
  return new Promise((resolve, reject) => {
    /** @type {ReturnType<typeof setInterval> | undefined} */
    let intervalId;
    const abortMessage = 'waiting for specific time was aborted';
    const interval = 5;
    const checkTime = () => {
      const now = getNow();
      if (now >= timeUs) {
        abortSignal.removeEventListener('abort', abortListener);
        clearInterval(intervalId);
        intervalId = undefined;
        return resolve();
      }
    };

    const abortListener = () => {
      abortSignal.removeEventListener('abort', abortListener);
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      clearInterval(intervalId);
      return reject(error);
    };

    abortSignal.addEventListener('abort', abortListener);
    intervalId = setInterval(checkTime, interval);
  });
}

/**
 * Funkce, která zjistí aktuální čas v mikrosekundách od UNIX epochy.
 * @callback GetNow
 * @returns {number} Čas od UNIX epochy v mikrosekundách.
 */
